module.exports = __webpack_public_path__ + "static/img/dataserviceIndex_5.b5d8667d.svg";